import { useEffect } from "react";

type DocumentHeadOptions = {
  title: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
};

const SITE_ORIGIN = "https://www.swiftmvp.com";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useDocumentHead({
  title,
  description,
  canonical,
  noindex,
}: DocumentHeadOptions) {
  useEffect(() => {
    document.title = title;

    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }

    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);

    const canonicalHref = canonical
      ? canonical.startsWith("http")
        ? canonical
        : `${SITE_ORIGIN}${canonical}`
      : `${SITE_ORIGIN}${window.location.pathname}`;
    upsertLink("canonical", canonicalHref);
    upsertMeta("property", "og:url", canonicalHref);

    upsertMeta(
      "name",
      "robots",
      noindex
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1",
    );
  }, [title, description, canonical, noindex]);
}
